/*
 *****************************************************************************
 *File :router.js
 *Module : Dashboard Frontend
 *Purpose :Defining the store variables for the cyberS Application
 *Author : UI Team
 *Copyright : Copyright 2021, Lab to Market Innovations Private Limited
 *****************************************************************************
 */

import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import notification from './notification/notification.store';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.localStorage,
    }),
  ],
  modules: {
    notification,
  },
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: require(`@/assets/images/jsw-sidebar.jpeg`),
    drawer: null,
    playDateInfo: '',
    start_endYard: '',
    pieCntArr: [],
    pointIds: [],
    logUser: [],
    logUserAdmin: [],
    logUserCCA: [],
    logUserType: [],
    operationNotPermitted: '',
    dialog: true,
    userSelectedSection: 'S0',
    resetFlagCS: 0,
    switchFlag: 0,
    resetInitial: 0,
    routingAlert: false,
    pointNotLockedAlert: false,
    orangeTimerEnabled: false,
    sectionStatusColor: 'grey',
    pointZoneSection: 0,
    sectionIdBlink: false,
    clearBlink: false,
    blinkCount: 0,
    barChartDates: [],
    barChartDates2: [],
    barChartDates3: [],
    barChartDates5: [],
    barChartDates6: [],
    barChartDates7: [],
    barChartDates8: [],
    barChartDates9: [],
    pieChartHABDDatas: [],
    user_ip: '',
    token: '',
    snackbar: false,
    username: '',
    trainCount: [],
    defectCount: [],
    trainCount2: [],
    defectCount2: [],
    trainCount3: [],
    defectCount3: [],
    trainCount5: [],
    defectCount5: [],
    trainCount6: [],
    defectCount6: [],
    trainCount7: [],
    defectCount7: [],
    trainCount8: [],
    defectCount8: [],
    trainCount9: [],
    defectCount9: [],
    seriesPie: [],
    seriestruePer: [],
    seriesTotalTrue: [],
    seriesTotalFalse: [],
    ackStatus: 0,
    isAdmin: false,
    latestAlert: null,
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_SCRIM(state, payload) {
      state.barColor = payload;
    },
    SET_PIE_CNT(state, payload) {
      state.pieCntArr = payload;
    },
    SET_USR_SEL_SECTION(state, payload) {
      state.userSelectedSection = payload;
    },
    SET_LOG_USER_TYPE(state, payload) {
      state.logUserType = payload;
    },
    SET_LATEST_ALERT(state, payload) {
      state.latestAlert = payload;
    },
    ACKNOWLEDGE_LATEST_ALERT(state) {
      if (state.latestAlert) {
        state.latestAlert.acknowledged = true;
        state.latestAlert.isNewAlert = false;
      }
    },
    CLEAR_NEW_ALERT_BADGE(state) {
      if (state.latestAlert) {
        state.latestAlert.isNewAlert = false;
      }
    },
    CLEAR_LATEST_ALERT(state) {
      state.latestAlert = null;
    },
    // ...existing code...
  },
  actions: {
    setLatestAlert({ commit }, alertObj) {
      commit('SET_LATEST_ALERT', alertObj);
    },
    acknowledgeLatestAlert({ commit }) {
      commit('ACKNOWLEDGE_LATEST_ALERT');
    },
    clearNewAlertBadge({ commit }) {
      commit('CLEAR_NEW_ALERT_BADGE');
    },
    clearLatestAlert({ commit }) {
      commit('CLEAR_LATEST_ALERT');
    },
    // ...existing code...
  },
  getters: {
    // ...existing code...
  },
});
